export default "__VITE_PUBLIC_ASSET__a14db56c__"